import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@justgiving/react-tracking';

import styles from './Share.scss';
import classnames from 'classnames';
import { useOptimizely } from '../../hooks/useOptimizely';
import { Experiments } from '../../constants/experiments';
import { useApp } from '../../hooks/useApp';
import { MODAL } from '../../context';

interface ShareProps {
  buttonClassName?: string;
  trackingIdentifier?: string;
}

const ShareComponent: FunctionComponent<ShareProps> = ({
  buttonClassName,
  trackingIdentifier,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const optimizely = useOptimizely();
  const { showModal } = useApp();

  const shareButtonOnClick = () => {
    showModal({ modal: MODAL.SHARE, overwrite: true });
    if (optimizely) {
      optimizely.track(Experiments.TrackingEvents.shareModalOpen);
    }
  };

  return (
    <>
      <Button
        className={classnames(
          'jg-btn',
          buttonClassName ? buttonClassName : styles.shareButton,
        )}
        onClick={() => shareButtonOnClick()}
        type="button"
        trackingData={{
          action_name: 'click',
          subtype: 'share',
          event: 'click',
          event_value: 'share',
        }}
        data-track={trackingIdentifier}
      >
        {t('common.share')}
      </Button>
    </>
  );
};

export const Share = ShareComponent;
